module.exports = __webpack_public_path__ + "img/grace_dress.b9f16c1e.jpg";